<template>
  <div class="m-5 md:m-15 2xl:m-20">
    <!-- Popup message alert if save is not possible (Evaluation in progress on this template) -->
    <EvalInProgress
      :evaluation-in-progress="evaluationInProgress"
      @massAssignation="displayAssignTemplate()"
      @showPreview="showPreview = true"
    />
    <!-- END Popup message alert -->

    <mass-template-assignation
      :opened="massAssignation"
      @close="massAssignation = false"
      :template="massAssignationTemplate"
    />


    <!-- BEGIN Popup confirm delete template -->
    <popup
      :opened="confirmDeleteTemplate > -1"
      @close="confirmDeleteTemplate = -1"
    >
      <!-- Screen to ask a confirmation to close current evaluation -->
      <div v-if="confirmDeleteTemplate == 0">
        <div class="my-5 xl:my-15">
          <h3 class="mb-5 md:mb-10 2xl:mb-15">
            Supprimer le modèle de page "{{ templateNameToDelete }}"
          </h3>

          <div class="mb-10">
            <p class="text-indigo-600 text-lg text-center">
              Êtes-vous sûr de vouloir supprimer la page "{{ templateNameToDelete }}" ?
            </p>
            <p class="text-indigo-600 text-lg text-center">
              Cette suppression sera définitive et irrévocable.
            </p>
          </div>

          <div class="flex justify-center bg-pink">
            <action-button
              class="mr-4"
              border-color="border-pink-600"
              text-color="text-pink-600"
              bg-color="bg-pink-300"
              libelle="ANNULER"
              @clickAction="confirmDeleteTemplate = -1"
            />
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              libelle="SUPPRIMER"
              type-shadow="shadow-pink"
              @clickAction="confirm_delete_template"
            />
          </div>
        </div>
      </div>
      <!-- END Screen to ask a confirmation to close current evaluation -->

      <!-- Screen to confirm the close -->
      <div v-if="confirmDeleteTemplate == 1">
        <h3 class="w-full text-indigo-600 mt-12 mb-10">
          Le modèle de page "{{ templateNameToDelete }}"<br>a bien été
          supprimé !
        </h3>
        <illustration
          name="basket"
          class="w-full m-5"
        />
      </div>
      <!-- END Screen to confirm the close -->

      <!-- If template to delete is assigned on at least 1 beneficiary -->
      <div v-if="confirmDeleteTemplate == 2">
        <div class="my-5 xl:my-15">
          <h3 class="mb-5 md:mb-10 2xl:mb-15">
            Supprimer le modèle de page "{{ templateNameToDelete }}"
          </h3>

          <div class="mb-5">
            <p class="text-indigo-600 text-lg text-center">
              Êtes-vous sûr de vouloir supprimer le modèle de page "{{ templateNameToDelete }}" ?
            </p>
            <p class="text-indigo-600 text-lg text-center">
              Cette suppression sera définitive et irrévocable.
            </p>
          </div>

          <div class="mb-10">
            <p class="text-pink-600 text-lg text-center">
              Attention, ce modèle de page est utilisé par
              {{ listAssignedUsersTemplate.length }} bénéficiaire<span
                v-if="listAssignedUsersTemplate.length > 1"
              >s</span>
              :
            </p>
            <p class="text-pink-600 text-lg text-center">
              <span
                v-for="(beneficiary, index) in listAssignedUsersTemplate"
                :key="beneficiary.id"
              >
                <span v-if="index > 0">-&nbsp;</span>{{ beneficiary.firstname }} <span class="uppercase">{{ beneficiary.lastname }}</span>
              </span>
            </p>
            <p class="text-pink-600 text-lg text-center">
              En cas de suppression, le modèle de page "{{ templatePageToAssignAfterDelete.name }}" leur sera attribué.
            </p>
          </div>

          <div class="flex justify-center bg-pink">
            <action-button
              class="mr-4"
              border-color="border-pink-600"
              text-color="text-pink-600"
              bg-color="bg-pink-300"
              libelle="ANNULER"
              @clickAction="confirmDeleteTemplate = -1"
            />
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              libelle="SUPPRIMER"
              type-shadow="shadow-pink"
              @clickAction="
                confirm_delete_template(templatePageToAssignAfterDelete)
              "
            />
          </div>
        </div>
      </div>
      <!-- END If template to delete is assigned on at least 1 beneficiary -->
    </popup>
    <!-- END Popup confirm delete template -->

    <!-- BEGIN Popup confirm deactivate template -->
    <deactivate-template-popup
      :confirm-deactivate-template="confirmDeactivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      :list-assigned-users-template="listAssignedUsersTemplate"
      :template-page-to-assign-after-delete="templatePageToAssignAfterDelete"
      @confirm_deactivate_template="
        (templatePageToAssignAfterDelete) => {
          confirm_deactivate_template(templatePageToAssignAfterDelete);
        }
      "
      @close="confirmDeactivateTemplate = -1"
    />
    <!-- END Popup confirm deactivate template -->

    <!-- BEGIN Popup confirm activate template -->
    <activate-template-popup
      :confirm-activate-template="confirmActivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      @confirm_activate_template="confirm_activate_template()"
      @close="confirmActivateTemplate = -1"
    />
    <!-- END Popup confirm activate template -->

    <!-- Popup modal preview -->
    <popup
      :opened="showPreview"
      @close="showPreview = false"
    >
      <div>
        <h3 class="mt-15 mb-15 w-full">
          {{ infosPage.libelle_template }}
        </h3>

        <list-grid
          :list-items="activities"
          v-if="activities && activities.length > 0"
          @displayNum="
            (index) => {
              itemDisplayed = index;
            }
          "
          is-accordion-items
        >
          <template #header>
            <div class="col-start-2 col-span-3">
              Activité
            </div>
            <div
              class="col-span-4"
              v-if="template[2].included"
            >
              Niveau de maîtrise
            </div>
            <div
              class="col-span-4"
              v-if="template[0].included"
            >
              Temps consacré
            </div>
          </template>
          <template #accordionDescription="{item, num}">
            <div class="col-span-1 place-self-center">
              <icon
                class="text-pink-600 transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': itemDisplayed === num }"
                name="chevron-right"
              />
            </div>
            <div class="col-span-3 text-base font-normal">
              <span>{{ item.name }}</span>
            </div>


            <div
              class="col-span-4 text-base font-normal"
              v-if="template[2].included"
            >
              <span
                v-if="item.lvl !== '' || item.lvl !== undefined || item.lvl !== null"
              >
                {{ item.lvl }}
              </span>
            </div>
            <div
              class="col-span-4 text-base italic font-normal"
              v-if="template[0].included"
            >
              <span
                v-if="item.time !== '' || item.time !== undefined || item.time !== null"
              >
                {{ item.time }}
              </span>
            </div>
          </template>
          <template
            #accordionContent="{item, num}"
          >
            <div class="grid grid-cols-12 md:space-x-3">
              <div
                v-for="(general, i) in ['time', 'lvl', 'requis', 'evo']"
                :key="`general${i}`"
                class="col-span-full md:col-span-3"
              >
                <input-select
                  v-if="template[i].included"
                  :name="template[i].libelle + num"
                  :libelle="template[i].libelle"
                  :value="item[general]"
                  :datas="template[i].criterions"
                />
              </div>

              <template
                v-for="(subTask, subTaskIndex) in [
                  {title: 'Tâches Principales', name: 'Tâche', accessor: 'tasks'},
                  {title: 'Pratiques Professionnelles', name: 'Pratique', accessor: 'pratiques_pro'},
                  {title: 'Connaissances associées', name: 'Connaissance', accessor: 'activity_connaissances'},
                  {title: 'Comportement / Attitudes', name: 'Comportement', accessor: 'activity_comportement'},
                ]"
              >
                <div
                  class="col-span-full uppercase text-indigo-600 text-base my-5"
                  :key="`subTaskTitle${subTaskIndex}`"
                >
                  {{ subTask.title }}
                </div>

                <list-grid
                  :key="`subTask${subTaskIndex}`"
                  class="col-span-full"
                  grid="grid-cols-11"
                  :list-items="item[subTask.accessor]"
                  v-if="item[subTask.accessor] && item[subTask.accessor].length > 0"
                >
                  <template #header>
                    <div class="ml-2 md:ml-10 col-span-4">
                      {{ subTask.name }}
                    </div>
                    <div class="col-span-2 hidden md:inline">
                      Auto-évaluation
                    </div>
                    <div class="col-span-2 hidden md:inline">
                      Dernière eval. ref.
                    </div>
                    <div class="col-span-2 hidden md:inline">
                      Nouvelle eval. ref.
                    </div>
                    <div class="col-span-5 md:hidden">
                      Evaluations
                    </div>


                    <div class="col-span-1 text-center">
                      Comm.
                    </div>
                  </template>
                  <template #accordionDescription="{item: subItem, subItemNum}">
                    <div class="row-start-1 row-span-3 md:row-span-1 col-span-4 text-sm ml-2 md: ml-10">
                      {{ subItem.name }}
                    </div>

                    <input-text
                      class="col-start-5 col-span-4 row-start-1 md:row-start-auto md:col-span-2"
                      libelle=""
                      :value="
                        template[4].criterions[
                          Math.floor(
                            Math.random() * template[4].criterions.length
                          )
                        ]?.value
                      "
                      :disabled="true"
                    />
                    <input-text
                      class="col-start-5 col-span-4 row-start-2 md:row-start-auto md:col-span-2"
                      libelle=""
                      :value="
                        template[4].criterions[
                          Math.floor(
                            Math.random() * template[4].criterions.length
                          )
                        ]?.value
                      "
                      :disabled="true"
                    />
                    <input-select
                      class="col-start-5 col-span-4 row-start-3 md:row-start-auto md:col-span-2"
                      libelle=""
                      :name="`${subItemNum}${num}${subTask.accessor}${subItem.name}`"
                      :value="subItem.auto"
                      :datas="template[4].criterions"
                    />

                    <icon-comment
                      class="col-span-1 row-start-2 md:row-start-auto place-self-center"
                      :name="`comment-${num}-${subItem.name}-${subItemNum}`"
                    />
                  </template>
                </list-grid>
              </template>
            </div>
          </template>
        </list-grid>
      </div>
    </popup>
    <!-- END Popup modal preview -->

    <div v-if="isEditable">
      <!-- Title -->
      <div class="flex justify-center">
        <input-title
          class="mb-5 md:mb-15 2xl:mb-20 w-3/4"
          name="title"
          :value="infosPage.libelle_template"
          :disabled="
            !$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER) ||
              this.evaluationInProgress
          "
          :error="true"
          :maxlength="40"
          @input="(value) => {infosPage.libelle_template = value;
          }
          "
          @valid="
            (title) => {
              SET_NAME_TEMPLATE_IN_LIST([infosPage.id_template, title]);
            }
          "
        />
      </div>
      <!-- END Title -->

      <!-- BEGIN Bloc action buttons -->
      <list-buttons
        :evaluation-in-progress="evaluationInProgress"
        :is-active="infosPage.is_active"
        @preview="
          () => {
            showPreview = true;
          }
        "
        @deactivateTemplate="displayConfirmDeactivateTemplate()"
        @activateTemplate="displayConfirmActivateTemplate()"
        @confirmDelete="
          () => {
            displayConfirmDeleteTemplate();
          }
        "
        @assignTemplate="displayAssignTemplate()"
        can-delete
      />
      <!-- END Bloc action buttons -->

      <!-- BEGIN Template content -->
      <div class="flex flex-col">
        <div
          v-for="(field, index) in template"
          :key="index"
          class="grid grid-cols-12 gap-x-4 gap-y-6 place-content-center mb-15"
        >
          <div class="col-span-full flex flex-col md:flex-row items-baseline">
            <span class="text-gray-900 text-base uppercase mr-3">{{
              field.libelle
            }}</span>
            <checkbox-indigo
              libelle="Inclure dans l'évaluation"
              name="inlude_field"
              :value="field.included"
              @input="
                (newValue) => {
                  field.included = newValue;
                }
              "
              v-if="!field.libelle.includes('Critères')"
            />
          </div>

          <!-- BEGIN list of criterions -->
          <div
            v-for="(crit, jndex) in field.criterions"
            :key="jndex"
            class="col-span-full lg:col-span-3 relative"
            :class="{'col-start-1' : jndex == 0}"
          >
            <input-text
              v-if="evaluationInProgress"
              libelle=""
              :placeholder="'Critère '+(jndex+1)"
              :value="crit.value"
              @input="
                (newValue) => {
                  $set(crit, 'value', newValue);
                }
              "
              :disabled="true"
            />
            <input-text
              v-else
              libelle=""
              :placeholder="'Critère '+(jndex+1)"
              :value="crit.value"
              @input="
                (newValue) => {
                  $set(crit, 'value', newValue);
                }
              "
              :disabled="!$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
            />

            <div
              v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
              class="absolute flex cursor-pointer bottom-8/12 left-11/12 p-2 2xl:p-2.5 items-center text-pink-600 bg-pink-100 border border-pink-600 border-opacity-25 rounded-full"
              @click="deleteCriterion(index, jndex)"
            >
              <icon
                name="close"
                class="h-2 w-2 2xl:h-2.5 2xl:w-2.5"
              />
            </div>
          </div>
          <!-- END list of criterions -->

          <!-- BEGIN Button to add a criterion -->
          <div
            v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
            class="col-start-1 col-span-full w-max-content w-max cursor-pointer flex hover:font-medium"
            @click="addCriterion(index)"
          >
            <span class="plus-button 2xl:h-10 2xl:w-10">
              <icon name="plus" />
            </span>
            <span class="text-base text-gray-600 ml-3 mt-1.5 flex-initial">
              Ajouter un critère
            </span>
          </div>
          <!-- END Button to add a criterion -->
        </div>
      </div>
      <!-- END Template content -->
    </div>
    <div v-else>
      <!-- Title -->
      <div class="mb-5 md:mb-15 2xl:mb-20">
        <h3>
          {{ this.infosPage.libelle_template }}
        </h3>
      </div>
      <!-- END Title -->

      <!-- BEGIN Bloc action buttons -->
      <list-buttons
        :evaluation-in-progress="evaluationInProgress"
        :is-active="infosPage.is_active"
        @preview="
          () => {
            showPreview = true;
          }
        "
        @deactivateTemplate="displayConfirmDeactivateTemplate()"
        @assignTemplate="displayAssignTemplate()"
        @activateTemplate="displayConfirmActivateTemplate()"
        :can-delete="false"
      />
      <!-- END Bloc action buttons -->

      <!-- Custom content -->
      <div class="mx-15">
        <!-- Contenu de la partie personnalisable -->
        <h3 class="text-lg text-gray-600">
          Le modèle de page {{ this.infosPage.libelle_template }} n'est pas
          modifiable.<br>
          Vous pouvez simplement
          <span v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)">activer ou désactiver</span><span v-else>visualiser</span> le modèle de page.
        </h3>
        <div class="my-15 flex justify-center">
          <illustration name="notAllowed" />
        </div>
      </div>
      <!-- END Custom content -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import InputText from '../../components/Inputs/InputText';
import InputSelect from '../../components/Inputs/InputSelect';
import CheckboxForm from '../../components/Inputs/CheckboxForm';
import ClickOutside from 'vue-click-outside';
import IconComment from '../../components/Inputs/IconComment';
import InputTitle from '../../components/Inputs/InputTitle';

import ActionButton from '../../components/ActionButton';
import ListButtons from './../../components/Templates/listButtons.vue';

import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import Popup from '../../components/Popup';

import store from '../../store';

import DeactivateTemplatePopup from './../../components/Templates/DeactivateTemplatePopup';
import ActivateTemplatePopup from './../../components/Templates/ActivateTemplatePopup';
import CheckboxIndigo from '../../components/Inputs/CheckboxIndigo';

import Constants from './../../constants';
import EvalInProgress from './EvalInProgress.vue';
import ListGrid from '../../components/AccordionTable/ListGrid.vue';

export default {
  components: {
    ListGrid,
    EvalInProgress,
    CheckboxIndigo,
    InputText,
    InputSelect,
    Icon,
    ActionButton,
    Popup,
    Illustration,
    IconComment,
    CheckboxForm,
    ListButtons,
    DeactivateTemplatePopup,
    ActivateTemplatePopup,
    InputTitle,
  },

  name: 'ReferentielPro',

  data() {
    return {
      confirmDeleteTemplate: -1,
      confirmDeactivateTemplate: -1,
      confirmActivateTemplate:-1,
      editName: false,
      dropDownMenu: false,
      template: [
        { type: 'multi', libelle: 'Temps consacré', criterions: [] },
        { type: 'multi', libelle: 'Niveau de maîtrise requis', criterions: [] },
        { type: 'multi', libelle: 'Niveau de maîtrise acquis', criterions: [] },
        { type: 'multi', libelle: 'Perspectives d\'évolution', criterions: [] },
        { type: 'multi', libelle: 'Critères d\'évaluation', criterions: [] },
      ],
      emptyTemplate:[
        { type: 'multi', libelle: 'Temps consacré', criterions: [] },
        { type: 'multi', libelle: 'Niveau de maîtrise requis', criterions: [] },
        { type: 'multi', libelle: 'Niveau de maîtrise acquis', criterions: [] },
        { type: 'multi', libelle: 'Perspectives d\'évolution', criterions: [] },
        { type: 'multi', libelle: 'Critères d\'évaluation', criterions: [] },
      ],
      showPreview: false,
      activities: [
        {
          name: 'Activité 1',
          lvl: '2. Intermédiaire',
          time: 'Secondaire (- de 50% du temps)',
          evo: 'Moyenne',
          requis: '2. Intermédiaire',
          tasks: [
            {
              name: 'Tâche 1',
              auto: '',
              last: '',
              eval: '',
            },
            {
              name: 'Tâche 2',
              auto: '',
              last: '',
              eval: '',
            },
            {
              name: 'Tâche 3',
              auto: '',
              last: '',
              eval: '',
            },
          ],
          pratiques_pro: [
            {
              name: 'Pratique 1',
              last: '',
              eval: '',
              cv: false,
            },
            {
              name: 'Pratique 2',
              last: '',
              eval: '',
              cv: false,
            },
            {
              name: 'Pratique 3',
              last: '',
              eval: '',
              cv: false,
            },
          ],
          activity_connaissances: [
            {
              name: 'Connaisance 1',
              last: '',
              eval: '',
              cv: false,
            },
            {
              name: 'Connaisance 2',
              last: '',
              eval: '',
              cv: false,
            },
            {
              name: 'Connaisance 3',
              last: '',
              eval: '',
              cv: false,
            },
          ],
          activity_comportement: [
            {
              name: 'Connaisance 1',
              last: '',
              eval: '',
              cv: false,
            },
            {
              name: 'Connaisance 2',
              last: '',
              eval: '',
              cv: false,
            },
            {
              name: 'Connaisance 3',
              last: '',
              eval: '',
              cv: false,
            },
          ],
        },
      ],
      itemDisplayed: -1,
      templateNameToDelete:'',
      templateNameToDeactivate:'',
      constants: Constants,
      massAssignation: false,
      massAssignationTemplate: {},
    };
  },

  mounted(){
    this.initPage();
  },

  async beforeRouteUpdate (to, from, next) {
    store.commit('app/SET_LOADING', true);
    let url = to.path.split('/modeles-de-page/')[1].split('/');

    await store.dispatch('template/change_page', url).then((response) => {
      this.initPage();
      next();
    });
  },

  methods: {
    ...mapActions({
      save_datas: 'template/save_datas',
      delete_template: 'template/delete_template',
      switchState:'template/switchState',
    }),

    ...mapMutations({
      SET_TEMPLATEVERSIONS: 'template/SET_TEMPLATEVERSIONS',
      SET_TEMPLATECONTENT: 'template/SET_TEMPLATECONTENT',
      SET_LIBELLE_TEMPLATE: 'template/SET_LIBELLE_TEMPLATE',
      SET_NAME_TEMPLATE_IN_LIST: 'template/SET_NAME_TEMPLATE_IN_LIST',
      SET_ISACTIVE: 'template/SET_ISACTIVE',
      SET_MESSAGEHEADER: 'template/SET_MESSAGEHEADER',
    }),

    loadEmptyForm(){
      this.template = [...this.emptyTemplate];
    },

    initTemplate(){
      if(this.templateContent.length > 0){
        //load values in form and keep templateContent with initial values to compare when leave page without saving
        this.template = [...this.templateContent];
      }
    },

    async initPage(){
      await this.loadEmptyForm();
      await this.initTemplate();

      this.confirmDeleteTemplate= -1;
      this.confirmDeactivateTemplate= -1;
      this.confirmActivateTemplate=-1;

      store.commit('app/SET_LOADING', false);
      this.infosPage.isTemplateChanged = false;
    },

    displayItem(numItem){
      if(this.itemDisplayed == numItem){
        this.itemDisplayed = -1;
      }else{
        this.itemDisplayed = numItem;
        let pos = document.getElementById('item'+numItem);
        setTimeout(() => {
          pos.scrollIntoView({ block: 'start' });
        }, 300);
      }
    },

    confirm_delete_template(templateToReplace = null){
      this.delete_template(templateToReplace), (this.confirmDeleteTemplate = 1);
    },

    displayDropdownMenu(){
      this.dropDownMenu = !this.dropDownMenu;
    },
    forceHide(e){
      if(e.target.classList.contains('dropdown-menu')){
        this.displayDropdownMenu();
      }else{
        if(this.dropDownMenu){
          this.dropDownMenu = false;
        }
      }
    },

    addField(type){
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template.push({ type: type, libelle: '', criterions: [] });
        this.dropDownMenu = false;
      }
    },

    deleteField(index){
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template.splice(index, 1);
      }
    },

    addCriterion(index){
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        if(this.template[index].criterions.length < 10){
          this.template[index].criterions.push({value: ''});
        }else{
          this.SET_MESSAGEHEADER({
            type: 'warning',
            msg: 'Vous avez atteint la limite de 10 critères maximum',
          });
          setTimeout(() => {
            this.SET_MESSAGEHEADER(null);
          }, 3000);
        }
      }
    },

    displayAssignTemplate() {
      this.massAssignationTemplate = {
        id: this.infosPage.id_template,
        name: this.infosPage.libelle_template,
        page_id: this.infosPage.id_page
      };
      this.massAssignation = true;
    },

    deleteCriterion(index, jndex){
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template[index].criterions.splice(jndex, 1);
      }
    },

    displayConfirmDeleteTemplate(){
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas supprimer le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }
      if(this.listAssignedUsersTemplate.length == 0){
        this.confirmDeleteTemplate = 0;
      }
      if(this.listAssignedUsersTemplate.length > 0){
        this.confirmDeleteTemplate = 2;
      }

      this.templateNameToDelete = this.infosPage.libelle_template;
    },

    displayConfirmDeactivateTemplate(){
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas désactiver le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }

      if(this.listAssignedUsersTemplate.length == 0){
        this.confirmDeactivateTemplate = 0;
      }

      if(this.listAssignedUsersTemplate.length > 0){
        this.confirmDeactivateTemplate = 2;
      }

      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    displayConfirmActivateTemplate(){
      this.confirmActivateTemplate = 0;
      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    confirm_deactivate_template(templateToReplace = null){
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: templateToReplace,
      });
      this.confirmDeactivateTemplate = 1;
    },

    confirm_activate_template(){
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: null,
      });
      this.confirmActivateTemplate = 1;
    },
  },

  computed: {
    ...mapGetters({
      infosPage: 'template/infosPage',
      listPageTemplates: 'template/listPageTemplates',
      templateVersions: 'template/templateVersions',
      templateContent: 'template/templateContent',
      evaluationInProgress: 'template/evaluationInProgress',
      listAssignedUsersTemplate: 'template/listAssignedUsersTemplate',
    }),

    templatePageToAssignAfterDelete(){
      let nextPageTemplate = this.listPageTemplates.filter(
        (t) =>
          t.page_name == this.infosPage.name_page &&
          t.id != this.infosPage.id_template &&
          t.is_active == 1
      );
      return nextPageTemplate.length > 0 ? nextPageTemplate[0] : null;
    },

    isEditable(){
      return (
        (typeof this.infosPage.editable === 'boolean' &&
          this.infosPage.editable === true) ||
        (typeof this.infosPage.editable === 'number' &&
          this.infosPage.editable === 1) ||
        (typeof this.infosPage.editable === 'string' &&
          this.infosPage.editable === '1')
      );
    },
  },

  watch:{
    template: {
      handler(){
        this.infosPage.isTemplateChanged = true;
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>